import * as React from 'react';
export const LASvg = React.forwardRef(function LASvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M1.994 0h12.012C15.106 0 16 .895 16 2v2H0V2C0 .888.893 0 1.994 0ZM0 8h16v2c0 1.112-.893 2-1.994 2H1.994C.894 12 0 11.105 0 10V8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M0 3h16v6H0z',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: 8,
        cy: 6,
        r: 2,
        fill: '#FFF',
      }),
    ),
  );
});
LASvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var LA = {
  category: 'flag',
  colorable: false,
  name: 'LA',
  svg: LASvg,
};
